<template>
	<div class="container">
		<div class="background"></div>

		<div class="wrapper">
			<div class="row">
				<div class="col-sm-4"></div>
				<div class="col-sm-4">
					<img src="../../assets/zoom-logo.png">
				</div>
				<div class="col-sm-4"></div>
		    </div>
			
			<fieldset>
				<div class="alert alert-danger" role="alert" v-if="errors.length > 0">
					<ul>
						<li v-for="error in errors">{{ error }}</li>
					</ul>
				</div>

				<legend>Fill your information</legend>

				<p>Admission is competitive, as there are limited spaces for freelancers on Upwork.</p>

				<p>Take your time to complete the following information. After you submit your application, we’ll notify you of our decision within 24 hours. </p>

				<form v-on:submit.prevent="register">
					
					<div class="row">
						<div class="col-sm-4">
							<label>Upload a professional portrait</label>	
						</div>
						
						<div class="col-sm-8">
							<button class="btn btn-outline">
								<i class="fas fa-plus-circle"></i> Add a photo</button>	
						</div>
					</div>

					<div class="row">
						<div class="col-sm-4">
							<label>Country</label>	
						</div>
						
						<div class="col-sm-8">
							<select class="form-control">
								<option></option>
								<option>Bulgaria</option>
							</select>	
						</div>
					</div>

					<div class="row">&nbsp;</div>
					
					<div class="row">
						<div class="col-sm-4">
							<label>
								What is the main service you offer to clients?
								<span class="required">*</span>
							</label>
						</div>

						<div class="col-sm-8">
							<select class="form-control">
								<option></option>
								<option>Blockchain Service</option>
							</select>
						</div>
					</div>

					<div class="row">&nbsp;</div>

					<div class="row">
						<div class="col-sm-4">
							<label>
								Which types of Web, Mobile & Software Dev do you do?
								<span class="required">*</span>
							</label>	
						</div>
						
						<div class="col-sm-8">
							<div class="row">
								<div class="col-sm-6">
									<div class="form-group">
										<input type="checkbox"> Desktop Software Development
									</div>

									<div class="form-group">
										<input type="checkbox"> Ecommerce Development	
									</div>
									
									<div class="form-group">
										<input type="checkbox"> Game Development	
									</div>

									<div class="form-group">
										<input type="checkbox"> Mobile Development	
									</div>

									<div class="form-group">
										<input type="checkbox"> Product Management
									</div>
								</div>

								<div class="col-sm-6">
									<div class="form-group">
										<input type="checkbox"> Product Management
									</div>

									<div class="form-group">
										<input type="checkbox"> QA & Testing
									</div>

									<div class="form-group">	
										<input type="checkbox"> Scripts & Utilities
									</div>	
									
									<div class="form-group">
										<input type="checkbox"> Web Development
									</div>	
									
									<div class="form-group">
										<input type="checkbox"> Web & Mobile Design
									</div>	
								</div>
							</div>
						</div>
					</div>

					<div class="row">&nbsp;</div>

					<div class="row">
						<div class="col-sm-4">
							<label>
								What skills do you offer clients?
								<span class="required">*</span>
							</label>
						</div>

						<div class="col-sm-8">
							<input type="text" class="form-control" placeholder="Enter skill here" />
								<button class="btn btn-default">
									<i class="fas fa-times"></i>&nbsp;Python Pandas
								</button>

								<button class="btn btn-default">
									<i class="fas fa-times"></i>&nbsp;Python Pandas
								</button>

								<button class="btn btn-default">
									<i class="fas fa-times"></i>&nbsp;Python Pandas
								</button>
						</div>
					</div>

					<div class="row">&nbsp;</div>

					<div class="row">
						<div class="col-sm-4">
							<label>
								What is your experience level?
								<span class="required">*</span>
							</label>
						</div>	

						<div class="col-sm-8">
							<div class="row">
								<div class="col-sm-4">
									<div class="box">
										<i class="fas fa-chess-pawn"></i>
										<p>Entry Level</p>
									</div>
								</div>	

								<div class="col-sm-4">
									<div class="box">
										<i class="fas fa-chess-knight"></i>
										<p>Mid Level</p>
									</div>
								</div>	

								<div class="col-sm-4">
									<div class="box">
										<i class="fas fa-chess-king"></i>
										<p>Top Level</p>
									</div>
								</div>	
							</div>
						</div>
					</div>

					<div class="row">&nbsp;</div>
					
					<div class="row">
						<div class="col-sm-4">
							<label>Bio 
								<span class="required">*</span>
							</label>
						</div>	

						<div class="col-sm-8">
							<textarea class="form-control"></textarea>
						</div>
					</div>

					<!-- <div class="form-group">
					    <label>Name</label>
					    <input type="text" class="form-control" v-model="name">
					</div>

					<div class="form-group">
					    <label>Email</label>
					    <input type="email" class="form-control" v-model="email">
					</div>

					<div class="form-group">
					    <label>Password</label>
					    <input type="password" class="form-control" v-model="password">
					</div>

					<div class="form-group">
					    <label>Confirm password</label>
					    <input type="password" class="form-control"  v-model="confirmPassword">
					</div> -->
					
					<div class="row">&nbsp;</div>
					<div class="row">
						<div class="col-sm-4"></div>

						<div class="col-sm-5">
							<button type="submit" class="btn btn-primary">Save</button>
						</div>
						<!-- <div class="col-sm-8"> -->
						<!-- </div> -->
					</div>
				</form>
			</fieldset>
		</div>
	</div>
</template>

<script type="text/javascript">
import firebase from 'firebase'

export default {
	data() {
		return {
			name : '',
			email : '',
			password: '',
			confirmPassword : '',
			errors : []
		}
	},
	methods : {
		register() {
			this.errors = [];
			// Validate the fields
			
			//check if the fields are empty
			if(this.name === '') {
				this.errors.push('The name can not be empty')
			}

			if(this.email === '') {
				this.errors.push('The email can not be empty')
			}

			if(this.password === ''){
				this.errors.push('The password can not be empty')
			}

			//check the regex for email
			if(!/\S+@\S+\.\S+/.test(this.email)) {
				this.errors.push('The email is not valid')
			}

			//check for minimum length of 6 characters
			if(this.password.length < 6) {
				this.errors.push('The length should be greater than 6')
			}

			if(this.confirmPassword === '') {
				this.errors.push('The confirm password can not be empty')
			}

			if(this.password !== this.confirmPassword) {
				this.errors.push('The passwords do not match');
			}

			if(this.errors.length) { return }

			var self = this;

			firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
			.then((user) => {
				var user = firebase.auth().currentUser
				
				user.updateProfile({
					displayName : this.name
				})
				.then(() => {
					console.log('The user is added')
				})
				.catch(() => {
					console.log('Problem with the user')
				})
			})
			.catch((error) => {
				this.errors.push(error.message)
			})
		}
	}
}
</script>

<style scoped>
@import '../../assets/css/stylesheet.css';

a {
	cursor: pointer;
}

.form-group,
.form-group label,
.form-group input { 
	float:left; 
	display:inline;   
	margin-right: 1em;
}

.form-group { margin-right:5px }

/*.form-group label { line-height:1px; }*/

.container {
	font-family: 'Gotham Pro';
}

.background {
	width: 100%;
	/*TODO: make it better*/
	height: 200%;
	top : 0;
	left : 0;
	bottom: 0;
	background-image: linear-gradient(to right,#042AB1,#012853);;
	position: absolute;
	z-index: -99999991;
}

.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column; 
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
}

fieldset {

	padding: 10px 20px 30px 20px;
	border-radius: 20px;
	width: 90%;
	max-width: 740px;
  	background: #ffffff;
  	position: relative;
  	box-shadow: 0px 1px 5px rgba(0,0,0,0.3);
}

fieldset p {
	text-align: center;
}

legend {
	text-align: center;
	padding-top: 2em;
	font-weight: 600;
}

.btn-outline {
	border: 1px solid #38DCAB;
	background-color: #FFF;
	color : #38DCAB;
}

.btn-primary {
	width: 100%;
	background-color: rgba(2, 41, 81, 0.98);
	border-radius: 15px;
	padding: 10px;
	border: 1px solid rgba(2, 41, 81, 0.98);
}

.box {
	width: 100%;
	/*height: 100%;*/
	border: 1px solid rgb(85, 85, 85);
	border-radius: 10px;
	opacity: 0.75;
}

.box:hover {
	color: rgb(56, 220, 171);
	border : 1px solid rgb(56, 220, 171);
}

.box i {
	font-size: 3em;
	text-align: center;
	display: block;
	padding: 0.2em;
}

.btn-default {
	margin-top: 0.5em;
}

.required {
	color: #FF0000;
	font-size: 1.4em;
}
</style>


// WEBPACK FOOTER //
// src/components/authentication/Register.vue